import { motion } from 'framer-motion'
import styled from 'styled-components'

// One fixed dropdown panel; width/height changes between the compact and
// expanded column sets are animated by the CSS transition below, the
// entry/exit fades by framer-motion.
//
// NOTE: About pointer events — same quirk as ModalV2: framer-motion
// sometimes runs the exit animation but leaves the element in the DOM, so
// the closed states must also kill pointer events or an invisible box
// keeps swallowing clicks.
export const MorphBox = styled(motion.div).attrs({
  variants: {
    initial: { opacity: 0, scale: 0.98, pointerEvents: 'none' as const },
    isOpen: { opacity: 1, scale: 1, pointerEvents: 'all' as const },
    exit: {
      opacity: 0,
      scale: 0.98,
      transition: { duration: 0.18 },
      pointerEvents: 'none' as const
    }
  },
  initial: 'initial',
  animate: 'isOpen',
  exit: 'exit'
})`
  position: fixed;
  background: ${({ theme }) => theme.colors.neutralWhite};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  z-index: 100000;
  overflow: hidden;
  transition: left 0.38s cubic-bezier(0.4, 0, 0.2, 1), top 0.38s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.38s cubic-bezier(0.4, 0, 0.2, 1), height 0.38s cubic-bezier(0.4, 0, 0.2, 1);
`

// Square icon-only control for the expand/minimize toggle.
export const IconButton = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.borderSoft};
  cursor: pointer;
  background: ${({ theme }) => theme.colors.neutralWhite};
  width: 34px;
  height: 34px;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.metalGray};
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) => theme.colors.neutralGray};
  }
`
